/* eslint-disable */
import Header from "../../component/Header/Header";
import "../../App.css";
import SPLogin from "./SPLogin";
import QPPOSLogin from "./QPPOSLogin";
import EmployeeLogin from "./EmployeeLogin";
import React,{ useEffect, useState } from "react";
import { encrypt, decryp } from "../../Constant/Encrypt";

function App() {
  const [paramsData, setParamsData] = useState();
  useEffect(() => {
    getQuery();
  }, []);
  const [intermedsubcatcd, setIntermedCategory] = useState("");
  const getQuery = () => {
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let query = params.get("q");
    var key = "lv39eptlvuhaqqer";
    if (query == null) {
      return;
    }

    if (query != null) {
      let encrypt = query.replace(/ /g, "+");
      let decryptedText = decryp(encrypt);
      var agentId = JSON.parse(decryptedText).agentId;
      var intermedsubcatcd = JSON.parse(decryptedText).intermedsubcatcd;
      var mobilenumber = JSON.parse(decryptedText).mobilenumber;
      var applicationNum = JSON.parse(decryptedText).applicationNum;
      var authorization = JSON.parse(decryptedText).authorization
        ? JSON.parse(decryptedText).authorization
        : false;
      var skip = JSON.parse(decryptedText).skip
        ? JSON.parse(decryptedText).skip
        : false;
      var productName = JSON.parse(decryptedText).productName
        ? JSON.parse(decryptedText).productName
        : "All Products";
      let dealerCode = JSON.parse(decryptedText).dealerCode;
      if (agentId !== null && intermedsubcatcd !== null) {
        var paramsData = {
          agentId: agentId,
          intermedsubcatcd: intermedsubcatcd,
          mobilenumber: mobilenumber,
          authorization: authorization,
          skip: skip,
          productName: productName,
          dealerCode:dealerCode,
          applicationNum: applicationNum
        };
        setParamsData(paramsData);
        setIntermedCategory(intermedsubcatcd);
      }
    }
  };
  const redirectPages = () => {
    if (intermedsubcatcd == "BROKER") {
      return <QPPOSLogin paramsData={paramsData} />;
    } else if (
      intermedsubcatcd == "SP" ||
      intermedsubcatcd == "AGENT" ||
      intermedsubcatcd == "IMF Broker Agent" ||
      intermedsubcatcd == "DUMMY" ||
      intermedsubcatcd == "POSP"
    ) {
      return <SPLogin paramsData={paramsData} />;
    } else if (intermedsubcatcd == "EMPLOYEE") {
      return <EmployeeLogin paramsData={paramsData} />;
    }else if (intermedsubcatcd == "POSP") {
      return <SPLogin paramsData={paramsData} />;
    }
  };
  return <>{intermedsubcatcd && redirectPages()}</>;
}

export default App;
